import DialogName from '../constants/DialogName';
import hideDialog from './hideDialog';

export default function hideAddFeatureWorksheet() {
  return hideDialog(DialogName.ADD_FEATURE_WORKSHEET)();
}
